import React, { useState, useEffect, useCallback } from "react";
import Layout from "../layout/Layout";
import { useAuth } from "../../components/context/AuthContext";
// getTickets API fonksiyonunu kendi yapına göre çağır
import { getTickets } from "../../api/ticketApi";

function TicketAnalizPage() {
  const { user, token } = useAuth();

  // Ana veriler
  const [dashboardData, setDashboardData] = useState({
    stats: null,
    tickets: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Filtreleme Stateleri
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [priorityFilter, setPriorityFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");

  // YENİ: Personel Filtresi
  const [selectedPerson, setSelectedPerson] = useState(null);

  // Modal (Detay) State'i
  const [selectedTicket, setSelectedTicket] = useState(null);

  // useCallback ile fetchData fonksiyonunu sarmalıyoruz
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getTickets(token);

      const responseData = response.data || response;
      const mainData = responseData?.data || {};

      setDashboardData({
        stats: mainData.stats || null,
        tickets: mainData.tickets || [],
      });
    } catch (err) {
      console.error("Dashboard verileri çekilirken hata:", err);
      setError("Sistem verileri yüklenirken bir sorun oluştu.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (user && token) {
      fetchData();
    }
  }, [user, token, fetchData]);

  if (!user) return null;

  if (loading) {
    return (
      <Layout>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
          }}
        >
          <h3 style={{ color: "#6c757d" }}>Sistem verileri yükleniyor...</h3>
        </div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div
          style={{
            textAlign: "center",
            color: "#721c24",
            padding: "20px",
            background: "#f8d7da",
            borderRadius: "8px",
          }}
        >
          {error}
        </div>
      </Layout>
    );
  }

  // --- 1. KISIM: ANALİZ VERİLERİ (STATS) ---
  const { stats, tickets } = dashboardData;
  const dateStats = stats?.timing || {
    thisWeekCount: 0,
    thisMonthCount: 0,
    totalCount: 0,
  };
  const departmentsData = stats?.departments || [];
  const typesData = stats?.types || [];

  const maxDeptCount =
    departmentsData.length > 0
      ? Math.max(...departmentsData.map((d) => d.count))
      : 1;

  // --- 2. KISIM: SÖZLÜKLER VE FORMATLAYICILAR ---
  const typeMap = {
    issue: { label: "Sorun / Hata", color: "#dc3545", tableLabel: "Sorun" },
    suggestion: {
      label: "Öneri / İyileştirme",
      color: "#ffc107",
      tableLabel: "Öneri",
    },
    request: { label: "Yeni Talep", color: "#0d6efd", tableLabel: "Talep" },
  };

  const priorityMap = {
    low: { label: "Düşük", bg: "#e2e3e5", color: "#383d41" },
    medium: { label: "Orta", bg: "#fff3cd", color: "#856404" },
    high: { label: "Yüksek", bg: "#f8d7da", color: "#721c24" },
    urgent: { label: "Acil", bg: "#dc3545", color: "#fff" },
  };

  const statusMap = {
    open: { label: "Açık", bg: "#cce5ff", color: "#004085" },
    in_progress: { label: "İşlemde", bg: "#fff3cd", color: "#856404" },
    resolved: { label: "Çözüldü", bg: "#d4edda", color: "#155724" },
    closed: { label: "Kapalı", bg: "#e2e3e5", color: "#383d41" },
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // --- Frontend Filtreleme Mantığı ---
  const filteredTickets = tickets.filter((ticket) => {
    const searchMatch =
      ticket.ticketNumber?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      ticket.description?.toLowerCase().includes(searchTerm.toLowerCase());

    const statusMatch =
      statusFilter === "all" || ticket.status === statusFilter;
    const priorityMatch =
      priorityFilter === "all" || ticket.priority === priorityFilter;
    const typeMatch = typeFilter === "all" || ticket.ticketType === typeFilter;

    // YENİ: Seçilen kişi filtresi
    const personMatch =
      !selectedPerson ||
      (ticket.relatedPersons &&
        ticket.relatedPersons.map((p) => p.trim()).includes(selectedPerson));

    return (
      searchMatch && statusMatch && priorityMatch && typeMatch && personMatch
    );
  });

  // --- PERSONEL SORUN ANALİZİ (Front-end'de hesaplama) ---
  const issueTickets = tickets.filter((t) => t.ticketType === "issue");
  const personIssueCounts = {};

  issueTickets.forEach((ticket) => {
    if (ticket.relatedPersons && Array.isArray(ticket.relatedPersons)) {
      ticket.relatedPersons.forEach((person) => {
        const pName = person.trim();
        if (pName) {
          personIssueCounts[pName] = (personIssueCounts[pName] || 0) + 1;
        }
      });
    }
  });

  const problematicPersons = Object.keys(personIssueCounts)
    .map((name) => ({ name, count: personIssueCounts[name] }))
    .sort((a, b) => b.count - a.count);

  return (
    <Layout>
      <section
        style={{
          flex: 1,
          maxWidth: "1200px",
          margin: "0 auto",
          background: "#f4f6f9",
          borderRadius: "18px",
          padding: "24px",
          boxSizing: "border-box",
          position: "relative",
        }}
      >
        <div style={{ marginBottom: "24px" }}>
          <h2
            style={{
              fontWeight: 600,
              color: "#283049",
              marginBottom: "8px",
              fontSize: "28px",
            }}
          >
            Sorun Çözüm Merkezi
          </h2>
        </div>

        {/* --- BÖLÜM 1: ANALİZ VE GRAFİKLER --- */}
        {stats && (
          <div style={{ marginBottom: "40px" }}>
            <div
              style={{
                display: "flex",
                gap: "20px",
                marginBottom: "24px",
                flexWrap: "wrap",
              }}
            >
              <StatCard
                title="Bu Hafta"
                count={dateStats.thisWeekCount}
                color="#17a2b8"
              />
              <StatCard
                title="Bu Ay"
                count={dateStats.thisMonthCount}
                color="#28a745"
              />
              <StatCard
                title="Toplam Talep"
                count={dateStats.totalCount}
                color="#6f42c1"
              />
            </div>

            <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
              <div
                style={{
                  flex: "1 1 400px",
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "16px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                }}
              >
                <h3
                  style={{
                    fontSize: "18px",
                    color: "#343a40",
                    marginBottom: "20px",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "10px",
                  }}
                >
                  Departmanlara Göre Dağılım
                </h3>
                {departmentsData.length > 0 ? (
                  departmentsData.map((dept, index) => {
                    const percentage = (dept.count / maxDeptCount) * 100;
                    return (
                      <div key={index} style={{ marginBottom: "16px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "6px",
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#495057",
                          }}
                        >
                          <span>{dept._id || "Bilinmeyen Departman"}</span>
                          <span>{dept.count} Talep</span>
                        </div>
                        <div
                          style={{
                            width: "100%",
                            height: "8px",
                            backgroundColor: "#e9ecef",
                            borderRadius: "4px",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              width: `${percentage}%`,
                              height: "100%",
                              backgroundColor: "#0056b3",
                              borderRadius: "4px",
                              transition: "width 1s ease-in-out",
                            }}
                          ></div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p style={{ color: "#6c757d", fontSize: "14px" }}>
                    Henüz departman verisi bulunmuyor.
                  </p>
                )}
              </div>

              <div
                style={{
                  flex: "1 1 400px",
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "16px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                }}
              >
                <h3
                  style={{
                    fontSize: "18px",
                    color: "#343a40",
                    marginBottom: "20px",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "10px",
                  }}
                >
                  Talep Tiplerine Göre
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {typesData.length > 0 ? (
                    typesData.map((type, index) => {
                      const typeInfo = typeMap[type._id] || {
                        label: type._id,
                        color: "#6c757d",
                      };
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            background: "#f8f9fa",
                            padding: "16px",
                            borderRadius: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "16px",
                              height: "16px",
                              borderRadius: "50%",
                              backgroundColor: typeInfo.color,
                              marginRight: "16px",
                            }}
                          ></div>
                          <div
                            style={{
                              flex: 1,
                              fontSize: "15px",
                              fontWeight: 600,
                              color: "#212529",
                            }}
                          >
                            {typeInfo.label}
                          </div>
                          <div
                            style={{
                              fontSize: "20px",
                              fontWeight: 700,
                              color: typeInfo.color,
                            }}
                          >
                            {type.count}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p style={{ color: "#6c757d", fontSize: "14px" }}>
                      Henüz talep tipi verisi bulunmuyor.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* --- BÖLÜM 2: TALEP TABLOSU VE FİLTRELER --- */}
        <div
          style={{
            background: "#fff",
            padding: "24px",
            borderRadius: "16px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
            marginBottom: "40px",
          }}
        >
          <div style={{ marginBottom: "20px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <h3 style={{ fontSize: "20px", color: "#343a40", margin: 0 }}>
                Tüm Talepler Listesi
              </h3>
              {selectedPerson && (
                <button
                  onClick={() => setSelectedPerson(null)}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Personel Filtresini Temizle ({selectedPerson})
                </button>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                background: "#f8f9fa",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <input
                type="text"
                placeholder="Talep No veya Açıklama Ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  flex: "1 1 200px",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                }}
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                  minWidth: "140px",
                }}
              >
                <option value="all">Tüm Durumlar</option>
                <option value="open">Açık</option>
                <option value="in_progress">İşlemde</option>
                <option value="resolved">Çözüldü</option>
                <option value="closed">Kapalı</option>
              </select>
              <select
                value={priorityFilter}
                onChange={(e) => setPriorityFilter(e.target.value)}
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                  minWidth: "140px",
                }}
              >
                <option value="all">Tüm Öncelikler</option>
                <option value="low">Düşük</option>
                <option value="medium">Orta</option>
                <option value="high">Yüksek</option>
                <option value="urgent">Acil</option>
              </select>
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                style={{
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                  fontSize: "14px",
                  minWidth: "140px",
                }}
              >
                <option value="all">Tüm Tipler</option>
                <option value="issue">Sorun / Hata</option>
                <option value="suggestion">Öneri</option>
                <option value="request">Yeni Talep</option>
              </select>
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "14px",
                textAlign: "left",
              }}
            >
              <thead>
                <tr
                  style={{
                    borderBottom: "2px solid #dee2e6",
                    color: "#495057",
                  }}
                >
                  <th style={{ padding: "12px", fontWeight: 600 }}>Talep No</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>Tarih</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>
                    Departman
                  </th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>İstasyon</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>Tip</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>Öncelik</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>Durum</th>
                  <th style={{ padding: "12px", fontWeight: 600 }}>Açıklama</th>
                  <th
                    style={{
                      padding: "12px",
                      fontWeight: 600,
                      textAlign: "center",
                    }}
                  >
                    İşlemler
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredTickets.length > 0 ? (
                  filteredTickets.map((ticket) => {
                    const priorityObj =
                      priorityMap[ticket.priority] || priorityMap.low;
                    const statusObj =
                      statusMap[ticket.status] || statusMap.open;
                    const typeObj = typeMap[ticket.ticketType];

                    return (
                      <tr
                        key={ticket._id}
                        style={{
                          borderBottom: "1px solid #e9ecef",
                          backgroundColor:
                            selectedPerson &&
                            ticket.relatedPersons?.includes(selectedPerson)
                              ? "#f8f9fa"
                              : "transparent",
                        }}
                      >
                        <td
                          style={{
                            padding: "12px",
                            fontWeight: 500,
                            color: "#0056b3",
                          }}
                        >
                          {ticket.ticketNumber || "-"}
                        </td>
                        <td style={{ padding: "12px", color: "#6c757d" }}>
                          {formatDate(ticket.createdAt)}
                        </td>
                        <td style={{ padding: "12px", color: "#212529" }}>
                          {ticket.department?.name || "-"}
                        </td>
                        <td style={{ padding: "12px", color: "#212529" }}>
                          {ticket.station || "-"}
                        </td>
                        <td style={{ padding: "12px", color: "#212529" }}>
                          {typeObj ? typeObj.tableLabel : ticket.ticketType}
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              backgroundColor: priorityObj.bg,
                              color: priorityObj.color,
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            {priorityObj.label}
                          </span>
                        </td>
                        <td style={{ padding: "12px" }}>
                          <span
                            style={{
                              backgroundColor: statusObj.bg,
                              color: statusObj.color,
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: 600,
                            }}
                          >
                            {statusObj.label}
                          </span>
                        </td>
                        <td
                          style={{
                            padding: "12px",
                            color: "#212529",
                            maxWidth: "150px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          title={ticket.description}
                        >
                          {ticket.description || "-"}
                        </td>
                        <td style={{ padding: "12px", textAlign: "center" }}>
                          <button
                            onClick={() => setSelectedTicket(ticket)}
                            style={{
                              padding: "6px 12px",
                              backgroundColor: "#e9ecef",
                              color: "#495057",
                              border: "1px solid #ced4da",
                              borderRadius: "6px",
                              cursor: "pointer",
                              fontSize: "13px",
                              fontWeight: 500,
                              transition: "0.2s",
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#dde2e6")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#e9ecef")
                            }
                          >
                            Detay
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="9"
                      style={{
                        textAlign: "center",
                        padding: "30px",
                        color: "#6c757d",
                      }}
                    >
                      Filtrelere uygun talep bulunamadı.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* --- BÖLÜM 3: KİM SORUN ÇIKARTIYOR ANALİZİ --- */}
        <div
          style={{
            background: "#fff",
            padding: "24px",
            borderRadius: "16px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
          }}
        >
          <h3
            style={{
              fontSize: "20px",
              color: "#343a40",
              marginBottom: "8px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            Personel Hata İstatistiği
          </h3>
          <p
            style={{ color: "#6c757d", fontSize: "14px", marginBottom: "20px" }}
          >
            Sadece "Sorun / Hata" olarak açılan taleplerde ilgili kişi olarak
            kimlerin adının geçtiğini gösterir. Tabloda filtrelemek için isme
            tıklayın.
          </p>

          {problematicPersons.length > 0 ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {problematicPersons.map((person, index) => {
                const isSelected = selectedPerson === person.name;

                return (
                  <div
                    key={index}
                    onClick={() =>
                      setSelectedPerson(isSelected ? null : person.name)
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: isSelected
                        ? "#e2e3e5"
                        : index === 0
                          ? "#fff3cd"
                          : "#f8f9fa",
                      border: isSelected
                        ? "2px solid #6c757d"
                        : index === 0
                          ? "1px solid #ffeeba"
                          : "1px solid #e9ecef",
                      padding: "16px 20px",
                      borderRadius: "12px",
                      flex: "1 1 250px",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: 600,
                        color: "#283049",
                      }}
                    >
                      {person.name}
                    </div>
                    <div
                      style={{
                        background: "#dc3545",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {person.count}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div
              style={{
                padding: "20px",
                background: "#d4edda",
                color: "#155724",
                borderRadius: "8px",
                textAlign: "center",
                fontWeight: 500,
              }}
            >
              Şu an sistemde hiç "Sorun" tipli talep bulunmuyor. Herkes iyi
              çalışıyor!
            </div>
          )}
        </div>
      </section>

      {/* --- DETAY MODALI --- */}
      {selectedTicket && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              width: "100%",
              maxWidth: "600px",
              borderRadius: "12px",
              padding: "24px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              position: "relative",
            }}
          >
            <h3
              style={{
                marginTop: 0,
                marginBottom: "16px",
                color: "#283049",
                fontSize: "22px",
                borderBottom: "1px solid #eee",
                paddingBottom: "12px",
              }}
            >
              Talep Detayı:{" "}
              <span style={{ color: "#0056b3" }}>
                {selectedTicket.ticketNumber}
              </span>
            </h3>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                marginBottom: "24px",
                fontSize: "15px",
                color: "#495057",
              }}
            >
              <div>
                <strong>Departman:</strong>{" "}
                {selectedTicket.department?.name || "-"}
              </div>
              <div>
                <strong>İstasyon:</strong> {selectedTicket.station || "-"}
              </div>
              <div>
                <strong>İlgili Kişiler:</strong>{" "}
                {selectedTicket.relatedPersons?.join(", ") || "-"}
              </div>
              <div>
                <strong>Tarih:</strong> {formatDate(selectedTicket.createdAt)}
              </div>
              <div>
                <strong>Açıklama:</strong>
                <div
                  style={{
                    background: "#f8f9fa",
                    padding: "12px",
                    borderRadius: "6px",
                    marginTop: "8px",
                    border: "1px solid #eee",
                  }}
                >
                  {selectedTicket.description}
                </div>
              </div>
              {selectedTicket.mediaUrl && (
                <div>
                  <strong>Medya/Link:</strong>{" "}
                  <a
                    href={selectedTicket.mediaUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#0056b3" }}
                  >
                    Dosyayı Görüntüle
                  </a>
                </div>
              )}
            </div>

            <div style={{ textAlign: "right" }}>
              <button
                onClick={() => setSelectedTicket(null)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

function StatCard({ title, count, color }) {
  return (
    <div
      style={{
        flex: "1 1 200px",
        background: "#fff",
        padding: "24px",
        borderRadius: "16px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
        borderLeft: `5px solid ${color}`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <span
        style={{
          fontSize: "14px",
          color: "#6c757d",
          fontWeight: 500,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {title}
      </span>
      <span
        style={{
          fontSize: "36px",
          fontWeight: 700,
          color: "#283049",
          marginTop: "8px",
        }}
      >
        {count}
      </span>
    </div>
  );
}

export default TicketAnalizPage;
